import { match, P } from 'ts-pattern';
import { ApplicationType } from '../graphql/operations';
import { FundingRound } from '../schemas/fundingRound/fundingRoundSchema';

export function getFutureCutoffDate(
  type: ApplicationType,
  round: Pick<
    FundingRound,
    'futureCoreCutoffDate' | 'futureOrionCutoffDate'
  > | null
) {
  return match([round, type])
    .with(
      [P.not(null), ApplicationType.Orion],
      ([{ futureOrionCutoffDate }]) => futureOrionCutoffDate
    )
    .with(
      [P.not(null), ApplicationType.Core],
      ([{ futureCoreCutoffDate }]) => futureCoreCutoffDate
    )
    .otherwise(() => undefined);
}
